"use strict";

var Model = require("../types/Model.js");
var xtend = require("xtend");
var Promise = require("promise");

module.exports = Model({
	name: "groups",

	_group_tracker: null,

	init: init,
	uninit: uninit,
	listeners: listeners,
	refresh: refresh,
	untrack_group_events: untrack_group_events,
	track_group_event: track_group_event
});

function init(){
	this._groups = [];
	this._group_tracker = this.dispatcher.createTracker();
	this.push([]);
}

function uninit(){
	this._groups = null;
	this._group_tracker = null;
}

function listeners(){
	return {
		"connectivity:online": refresh,
		"mqtt:$/groupchat/added": handle_added,
		"mqtt:$/groupchat/removed": handle_removed,
		"loadchecker:ready": initial_load
	};
}

function initial_load(){
	this._ready = true;
	this.refresh();
}

function refresh(){
	if(!this._ready) return Promise.resolve([]);
	return this.api.groupchat.list()
		.then(set_groups.bind(this))
		.then(track_groups_events.bind(this));
}

function handle_added(group){
	var newGroup = group.group;
	this.api.groupchat.data(newGroup)
		.then(add_group.bind(this));
}

function add_group(group){
	var newList = this._groups.concat(group);
	this._groups = newList;
	this.push(newList);
	this.track_group_event(group._id);
}

function handle_removed(group){
	var removedGroup = group.group;
	var groups = this._groups;
	var newList = groups.filter(function(element){
		return element._id !== removedGroup;
	});
	this.untrack_group_events(removedGroup);
	this._groups = newList;
	this.push(newList);
	this.emit("unreadnotifications:trigger:refresh");
	this.emit("readnotifications:trigger:refresh");
}

function handle_group_updated(updatedGroup){
	var groups = this._groups;
	var updatedGroups = groups.map(function(group){
		if(group._id === updatedGroup.group){
			var update = {
				name: updatedGroup.name,
				description: updatedGroup.description
			};
			var newGroup = xtend(group, update);
			return newGroup;
		}
		return group;
	});
	this._groups = updatedGroups;
	this.push(updatedGroups);
}

function set_groups(groups){
	this._groups = groups;
	this.push(groups);
	return groups;
}

function track_groups_events(){
	var groups = this._groups;
	var tracker = this._group_tracker;

	tracker.off();
	groups.forEach(function(group){
		this.track_group_event(group._id);
	}.bind(this));
}

function track_group_event(group_id){
	var tracker = this._group_tracker;
	this.untrack_group_events(group_id);
	tracker.on("mqtt:gc/" + group_id + "/settings/updated", handle_group_updated.bind(this));
}

function untrack_group_events(group_id){
	var tracker = this._group_tracker;
	tracker.off("mqtt:gc/" + group_id + "/settings/updated");
}
